import * as React from 'react';
import { isMobile } from 'react-device-detect';
import { Block, Heading, Text, Icon } from '../../../../../components';
import iconSuccess from '../../../../../../assets/illustrations/message_send.svg';
import IDHelpers from '../../../../../../core/helpers/IDHelper';
import { InteractiveButton } from '../../../components';

interface SuccessMessageProps {
  onClickPrimary: () => void;
  onClickSecondary: () => void;
}
const SuccessMessage = (props: SuccessMessageProps) => {
  const { onClickPrimary, onClickSecondary } = props;
  return (
    <Block
      customized
      maxWidth={isMobile ? '100%' : '496px'}
      backgroundColor="#fff"
      padding="0px 32px 32px 32px"
      margin="8px 0px 0px 0px"
      display="flex"
      justifyContent="center"
      alignItems="center"
      data-testid="cmp-success-message"
    >
      <Block
        customized
        display="flex"
        justifyContent="center"
        alignItems="center"
        margin="0px 0px 16px"
      >
        <img src={iconSuccess} alt="" />
      </Block>
      <Heading
        key={IDHelpers.generateID()}
        text="Tu registro ha sido enviado"
        level={2}
        color="#161D1F"
        size={20}
        lineHeight={32}
        fontWeight="900"
        className=""
        align="center"
        width="100%"
      />
      <Text
        key={IDHelpers.generateID()}
        textAlign="center"
        fontWeight="400"
        fontSize="14px"
        lineHeight="20px"
      >
        Nuestro personal de soporte estará revisando a la brevedad.
      </Text>
      <Block
        customized
        flexDirection="row"
        alignItems="flex-start"
        borderRadius="8px"
        margin="12px 0px 0px 0px"
        maxWidth="100%"
        backgroundColor="#ECF4F9"
        padding="8px 16px"
      >
        <Block customized margin="0px 12px 0px 0px" style={{ width: 'auto' }}>
          <Icon name="info" size={15} />
        </Block>
        <Text
          color="#161D1F"
          fontSize="12px"
          lineHeight="16px"
          fontWeight="400"
          witdh="100%"
        >
          Toda la información será enviada a tu correo institucional.
        </Text>
      </Block>
      <Block
        customized
        margin="32px 0 0 0"
        flexDirection={isMobile ? 'column' : 'row'}
        alignItems="center"
        justifyContent="center"
      >
        <Block
          style={{
            alignSelf: isMobile ? 'center' : 'flex-start',
            width: isMobile ? '100%' : 'auto'
          }}
        >
          <InteractiveButton
            data-testid="cmp-success-message-primary-button"
            bkgColorEnabled="#5B36F2"
            bkgColorHover="#745EF6"
            bkgColorFocus="#4318CD"
            bkgColorPressed="#4318CD"
            customized
            alignItems="center"
            backgroundColor="#5B36F2"
            padding="10px 0px"
            borderRadius="4px"
            width={isMobile ? '100%' : '99px'}
            onClick={onClickPrimary}
          >
            <Text
              color="#FFFFFF"
              fontSize="14px"
              lineHeight="20px"
              fontWeight="700"
              textAlign="center"
            >
              Entiendo
            </Text>
          </InteractiveButton>
        </Block>
        <Block
          style={{
            alignSelf: isMobile ? 'center' : 'flex-start',
            width: isMobile ? '100%' : 'auto'
          }}
        >
          <InteractiveButton
            data-testid="cmp-success-message-secondary-button"
            bkgColorEnabled="none"
            bkgColorHover="#E2DFFD"
            bkgColorFocus="#C6C0FC"
            bkgColorPressed="#C6C0FC"
            customized
            border="1px solid #5B36F2"
            alignItems="center"
            backgroundColor="#FFFFFF"
            padding="9px 4px"
            margin={isMobile ? '12px 0px 0px 0px' : '0px 0px 0px 16px'}
            borderRadius="4px"
            width="100%"
            onClick={onClickSecondary}
          >
            <Text
              color="#5B36F2"
              fontSize="14px"
              lineHeight="20px"
              fontWeight="700"
              textAlign="center"
            >
              Ver mis trámites
            </Text>
          </InteractiveButton>
        </Block>
      </Block>
    </Block>
  );
};
export default SuccessMessage;
